import { useLocation } from 'react-router-dom';
import SignupLanding from '../pages/auth/signup/SignupLanding';
import SignupDetails from '../pages/auth/signup/SignupDetails';
import SignupEmailVerification from '../pages/auth/signup/SignupEmailVerification';
import SignupPassword from '../pages/auth/signup/SignupPassword';

function SignupStepWrapper() {
  const location = useLocation();
  const step = location.state?.step || 'landing';

  switch (step) {
    case 'details':
      return <SignupDetails />;
    case 'emailVerification':
      return <SignupEmailVerification />;
    case 'createPassword':
      return <SignupPassword />;
    default:
      return <SignupLanding />;
  }
}

export default SignupStepWrapper;
